import axios from '@/utils/axios'

export const createCustomerContact = (payload) => {
  return axios.post('/customer_contact', payload)
}

export const getCustomerContact = (payload ) => {
  return axios.get(`/customer_contact/`, {
    params: payload
  })
}

export const getCustomerContactById = (id) => {
  return axios.get(`/customer_contact/${id}`)
}

export const updateCustomerContact = (id, data) => {
  return axios.put(`/customer_contact/${id}`, data)
}

export const deleteCustomerContact = (id) => {
  return axios.delete(`/customer_contact/${id}`)
}